export default "__VITE_PUBLIC_ASSET__3af04f48__"